"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredOptions = void 0;
const react_1 = __importStar(require("react"));
const SelectItem_1 = require("../SelectItem");
const SelectList_styles_1 = require("../SelectList/SelectList.styles");
const FilteredOptions = ({ groupedOptions, displayLimit, shouldDisplayValues, valueDescription, onListItemClick, }) => {
    const [currentLimit, setCurrentLimit] = (0, react_1.useState)(displayLimit);
    let focusIndex = 2; // The index is used for focus order when using a keyboard select box has tabindex = 1 so we start the items on 2
    let position = 1; // This is used for the aria-posinset labelling
    let optionsDisplayed = 0; // Need to remove any item that is over the displayLimit
    let optionsTotal = 0; // Need to calculate the number of all the options to assign the aria-setsize
    const filteredGroup = groupedOptions.reduce((acc, group) => {
        optionsTotal += group.options.length;
        // Don't add group if we are over the limit
        if (optionsDisplayed >= currentLimit) {
            return acc;
        }
        // Only keep options under the limit
        const options = [];
        group.options.forEach((item) => {
            if (optionsDisplayed < currentLimit) {
                optionsDisplayed += 1;
                options.push(item);
            }
        });
        acc.push(Object.assign(Object.assign({}, group), { options }));
        return acc;
    }, []);
    const handleClickMore = () => {
        setCurrentLimit((prev) => prev + displayLimit);
    };
    const displayMore = optionsDisplayed < optionsTotal;
    if (displayMore) {
        optionsDisplayed += 1;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        filteredGroup.map((groupedOption, index) => (react_1.default.createElement(react_1.Fragment, { key: index },
            groupedOption.heading && (react_1.default.createElement(SelectList_styles_1.StyledSelectListHeader, null, groupedOption.heading)),
            groupedOption.options.map((option, i) => {
                const newOption = (react_1.default.createElement(SelectItem_1.SelectItem, { option: option, index: focusIndex, key: i, ariaPosInset: position, ariaSetSize: optionsDisplayed, shouldDisplayValue: shouldDisplayValues, valueDescription: valueDescription, onListItemClick: onListItemClick }));
                focusIndex += 1;
                position += 1;
                return newOption;
            })))),
        displayMore && (react_1.default.createElement(SelectList_styles_1.StyledSelectMore, { id: "select-item-more", role: "option", onClick: handleClickMore, "data-testid": "select-item-more", "aria-posinset": position, "aria-setsize": optionsDisplayed, tabIndex: 0 }, "Show more results"))));
};
exports.FilteredOptions = FilteredOptions;
//# sourceMappingURL=FilteredOptions.js.map